import React, { Component } from "react";
import FlexView from "react-flexview";
import ModalContainer from "../../../../modules/commons/ModalContainer";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import SimpleAlert from "../../../../modules/popup/SimpleAlert";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import SimpleDataTable from "../../../../modules/SimpleDataTable";
import SimpleDate from "../../../../modules/SimpleDate";
import SimpleInput from "../../../../modules/SimpleInput";
import ReceivingPartDGIProcess from "./receivingPartDGIProcess";
import Api from "../../../../Services/Api";
import * as R from "ramda";
import SimpleLoadingOverlay from "../../../../modules/popup/SimpleLoadingOverlay";
import { defaultTableChange } from "../../../../modules/custom/customTable";

class ReceivingPartDGIDetail extends Component {
  tableColumns = [
    {
      name: "",
      label: "No",
      options: {
        customBodyRender: (value, tableMeta) => {
            return <>{tableMeta.rowIndex + 1}</>;
        },
        sort: false,
      },
    },
    {
      name: "part.partCode",
      label: "Kode Part",
    },
    {
      name: "part.partName",
      label: "Nama Part",
    },
    {
      name: "part.partCategory",
      label: "Kategori",
    },
    {
      name: "quantity",
      label: "QTY",
    },
    {
      name: "purchaseOrderNo",
      label: "No PO",
    },
    {
      name: "orderType",
      label: "Jenis Order",
    },
  ];

  constructor(props) {
    super(props);
    this.selectedData = props.state.selectedData;
    this.totalNonEditable =
      this.selectedData?.data?.length > 0 &&
      this.selectedData?.data?.filter((u) => !u.editable);
    this.state = {
      alertVisible: false,
      processModalVisible: false,
      loading: false,
      dataTable: [],
      pagination: {
        page: 1,
        limit: 5,
        totalData: 0,
      },
      // dataTableSample: [
      //   { kodePart: "12345", namaPart: "CLAMPER_CABLE", kategori: "CABLE", qty: 25, noPo: "P-EGKHCB-20200702-16042024", jenisOrder: "Hotline" }
      // ],
    };
  }

  handleProcess = async () => {
    const { data } = this.selectedData;

    // const missingList = data
    //     .filter(i => R.isNil(i.idWarna))
    //     .map(i => i.engineNumber);

    // const missingAlert = missingList.length > 0;
    // if (missingAlert) {
    //     this.setState({missingColorAlert: missingAlert, missingColorList: missingList});
    //     return;
    // }

    // const editableUnit =
    //     this.selectedData.data.length > 0 &&
    //     this.selectedData.data.filter((u) => u.editable);
    // if (editableUnit.length > 0) {
    //     this.setState((prevValue) => ({...prevValue, loading: true}));
    //     const listNosin = editableUnit.map((u) => u.engineNumber);
    //     await Api.create("NAGAMAS_TRANSACTION").validateReceivingDGIDetail(listNosin);
    //     this.setState((prevValue) => ({...prevValue, alertVisible: true, loading: false}));
    //     return;
    // }

    this.handleProcessVisibility();
  };

  handleProcessVisibility = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      processModalVisible: !prevValue.processModalVisible,
    }));
  };

  handleAlertModalVisibility = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      alertVisible: false,
      processModalVisible: !prevValue.processModalVisible,
    }));
  };

  handleChangePage = (tableState) => {
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        ...prevValue.pagination,
        page: tableState.page + 1,
      },
    }));
  };

  handleRowsPerPage = (tableState) => {
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        ...prevValue.pagination,
        page: 1,
        limit: tableState.rowsPerPage,
      },
    }));
  };

  render() {
    const { pagination } = this.state;
    console.log(this.selectedData);

    return (
      <>
        <SimpleModal
          title="Detail Penerimaan Part - DGI"
          visible={this.props.state.detailVisible}
          onClickClose={this.props.onShowModal}
          content={
            <ModalContainer>
              <div
                className="grid grid-2x grid-mobile-none gap-15px"
                style={{ alignItems: "center" }}
              >
                <div id="grid-1">
                  <SimpleDate
                    id="select_date_tanggal_sl"
                    label="Tanggal SL"
                    date={this.selectedData.shippingDate}
                    disabled
                  />
                  <SimpleInput
                    id="input_text_nosl"
                    name="nosl"
                    label="No. Shipping List (SL)"
                    readOnly
                    value={this.selectedData.shippingNo}
                  />
                </div>
                <div id="grid-2">
                  <SimpleInput
                    id="input_text_noinvoice"
                    name="noinvoice"
                    label="No. Penerimaan"
                    readOnly
                    value={this.selectedData.receivedNo}
                  />
                  <SimpleInput
                    id="input_text_jumlah"
                    name="totalQuantity"
                    label="Jumlah"
                    value={this.selectedData.totalQuantity}
                    readOnly
                  />
                </div>
              </div>
              <h3 className="margin-bottom-10px">Detail Penerimaan :</h3>
              <SimpleDataTable
                key={`${pagination.totalData}-${pagination.page}`}
                data={this.selectedData.data}
                columns={this.tableColumns}
                toCount={this.selectedData?.data.length}
                rowsPerPage={pagination.limit}
                page={pagination.page - 1}
                options={{
                  ...defaultTableChange(
                    this.handleChangePage,
                    this.handleRowsPerPage,
                  ),
                  serverSide: false,
                }}
              />
              <br />
              <FlexView hAlignContent="right" style={{ gap: "10px" }}>
                <SimpleButton
                  type="button"
                  onClick={() => this.handleProcessVisibility()}
                >
                  Proses
                </SimpleButton>
              </FlexView>
            </ModalContainer>
          }
        />
        {this.state.processModalVisible && (
          <ReceivingPartDGIProcess
            data={this.selectedData}
            visible={this.state.processModalVisible}
            onCloseDetail={() => this.props.onShowModal()}
            onClickClose={() => this.handleProcessVisibility()}
          />
        )}
        {this.state.alertVisible && (
          <SimpleAlert
            visible={this.state.alertVisible}
            onClickClose={this.handleAlertModalVisibility}
            content={
              <p>
                Ada {this.totalNonEditable.length}/
                {this.selectedData.data.length} data Noka atau Nosin yang sudah
                ada di NOS.
              </p>
            }
            additionalButtons={
              <SimpleButton onClick={this.handleAlertModalVisibility}>
                OK
              </SimpleButton>
            }
          />
        )}
        {this.state.loading && (
          <SimpleLoadingOverlay active={this.state.loading} />
        )}
      </>
    );
  }
}

export default ReceivingPartDGIDetail;
